import React from 'react'

const ArrowUpSortIcon = props => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : 24} height={props.height ? props.height : 24} viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
         className="lucide lucide-arrow-up-narrow-wide-icon lucide-arrow-up-narrow-wide">
        <path d="m3 8 4-4 4 4"/>
        <path d="M7 4v16"/>
        <path d="M11 12h4"/>
        <path d="M11 16h7"/>
        <path d="M11 20h10"/>
    </svg>
)

export default ArrowUpSortIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/ArrowUpSortIcon.jsx